import { render } from "./SlideComponent.vue?vue&type=template&id=57796768"
import script from "./SlideComponent.vue?vue&type=script&lang=js"
export * from "./SlideComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__